var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.237 7c1.986 0 3.594-1.566 3.594-3.5S15.223 0 13.237 0c-1.985 0-3.593 1.566-3.593 3.5S11.252 7 13.237 7zM5.153 5.25V2.625H3.356V5.25H.661V7h2.695v2.625h1.797V7h2.695V5.25H5.153zm8.084 3.5c-2.398 0-7.186 1.172-7.186 3.5V14h14.373v-1.75c0-2.328-4.788-3.5-7.187-3.5z",
    fill: "#2C58B1"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyMSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjIzNzQgN0MxNS4yMjI3IDcgMTYuODMwNiA1LjQzMzc1IDE2LjgzMDYgMy41QzE2LjgzMDYgMS41NjYyNSAxNS4yMjI3IDAgMTMuMjM3NCAwQzExLjI1MjIgMCA5LjY0NDE4IDEuNTY2MjUgOS42NDQxOCAzLjVDOS42NDQxOCA1LjQzMzc1IDExLjI1MjIgNyAxMy4yMzc0IDdaTTUuMTUyNjYgNS4yNVYyLjYyNUgzLjM1NjA1VjUuMjVIMC42NjExMzNWN0gzLjM1NjA1VjkuNjI1SDUuMTUyNjZWN0g3Ljg0NzU3VjUuMjVINS4xNTI2NlpNMTMuMjM3NCA4Ljc1QzEwLjgzODkgOC43NSA2LjA1MDk2IDkuOTIyNSA2LjA1MDk2IDEyLjI1VjE0SDIwLjQyMzhWMTIuMjVDMjAuNDIzOCA5LjkyMjUgMTUuNjM1OSA4Ljc1IDEzLjIzNzQgOC43NVoiIGZpbGw9IiMyQzU4QjEiLz4KPC9zdmc+Cg==";
export { SvgAddMember as ReactComponent };